import React from 'react';
import {useSelector} from 'react-redux';

import {useChatContext} from '/provider/ChatProvider';
import {credentialsEmail} from '/redux/selector/auth.selector';
import {
  variablesChatBetaUserEmails,
  variablesFeatureFlag,
} from '/redux/selector/remoteConfig.selector';
import {isEmailAllowlisted} from '/util/emailAllowlist.util';
import {shouldReleaseFeature} from '/util/featureRelease.util';

import ChatModal from './ChatModal';

const Chat: React.FC = () => {
  const featureFlag = useSelector(variablesFeatureFlag);
  const chatBetaUserEmails = useSelector(variablesChatBetaUserEmails);
  const email = useSelector(credentialsEmail);
  const {ff_chat = '', ff_chat_timestamp = ''} = featureFlag || {};
  const showChatFeature = shouldReleaseFeature(ff_chat);
  const showMessageTimestampFeature = shouldReleaseFeature(ff_chat_timestamp);
  const canAccessChat = isEmailAllowlisted({
    email,
    allowedEmails: chatBetaUserEmails,
  });
  const {isChatVisible, hideChat, sendMessage} = useChatContext();

  if (!showChatFeature || !canAccessChat) {
    return null;
  }

  return (
    <>
      <ChatModal
        visible={isChatVisible}
        onClose={hideChat}
        showMessageTimestamp={showMessageTimestampFeature}
        onSendMessage={sendMessage}
      />
    </>
  );
};

export default Chat;
